// extracted by mini-css-extract-plugin
export default {"root":"vAU8Qm","content":"kiyM2X"};